import {ADD_USER} from "../../common/actionTypes";

export const addUser = function (username: string, status: number) {
    return {
        type: ADD_USER,
        payload: {username, status}
    }
}